
const steps = [
  {
    number: '01',
    title: 'Audit',
    description: 'We analyze your current site and identify what\'s costing you jobs.'
  },
  {
    number: '02',
    title: 'Rebuild',
    description: 'We design and build a conversion-focused website from the ground up.'
  },
  {
    number: '03',
    title: 'Launch',
    description: 'We deploy your new site and ensure everything works perfectly.'
  },
  {
    number: '04',
    title: 'Generate More Calls',
    description: 'Watch as your new site starts bringing in more leads and bookings.'
  }
];

export default function Process() {
  return (
    <section className="py-24 px-6 bg-[#0A0A0A]">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-black text-center mb-16">
          Our Process Is <span className="text-[#3B82F6]">Simple.</span>
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-[#3B82F6] to-transparent"></div>
              )}
              
              <div className="bg-[#151515] border-2 border-[#3B82F6]/20 rounded-xl p-6 hover:border-[#3B82F6] transition-all relative z-10">
                <div className="text-6xl font-black text-[#3B82F6]/20 mb-4">{step.number}</div>
                <h3 className="text-2xl font-black mb-3 text-white">{step.title}</h3>
                <p className="text-gray-400 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
